import React from 'react'
import Zoom from 'react-medium-image-zoom'
import styled from 'styled-components'

import 'react-medium-image-zoom/dist/styles.css'

const ZoomImageWrapper = styled.div`
  margin: 16px auto;
  padding: 8px;

  :global {
    [data-rmiz-wrap='visible'],
    [data-rmiz-wrap='hidden'] {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
`

export const CustomImage = styled.img`
  display: block;
  width: 100%;
  max-height: 400px;
  object-fit: contain;
`

const ZoomImage = (props) => {
  return (
    <ZoomImageWrapper>
      <Zoom>
        <CustomImage src={props.src} alt={props.alt} {...props} />
      </Zoom>
    </ZoomImageWrapper>
  )
}

export default ZoomImage
